import { useState, useEffect } from "react";
import ApiClient from "../../methods/api/apiClient";
import loader from "../../methods/loader";
import methodModel from "../../methods/methods";
import { Link, useNavigate, useParams } from "react-router-dom";
import Layout from "../../components/global/layout";
import { Tooltip } from "antd";
import FormControl from "../../components/common/FormControl";
import { FiPlus } from "react-icons/fi";
import { IoCloseOutline } from "react-icons/io5";
import Select from "react-select"
import Swal from "sweetalert2";

const AddEditSubCategory = () => {
  const history = useNavigate();
  const { id } = useParams();
  const [submitted, setSubmitted] = useState(false);
  const [form, setform] = useState({ name: "", image: "" })
  const [categories, setCategories] = useState([])
  const formValidation = [
    { key: "name", required: true, message: "Sub Category name is required" },
  ]

  useEffect(() => {
    getCategories()
    if (id) {
      getSubCategoryDetail()
    }
  }, [])

  const getCategories = () => {
    ApiClient.get(`category/listing?status=active`).then(res => {
      if (res?.success) {
        setCategories(res?.data?.map((item) => {
          return ({ value: item?.id || item?._id, label: item?.name })
        }))
      }
    })
  }

  const getSubCategoryDetail = () => {
    loader(true)
    ApiClient.get(`category/detail?id=${id}`).then((res) => {
      if (res.success) {
        setform({
          name: res?.data?.name,
          image: res?.data?.image,
          categoryId: res?.data?.categoryId?._id ? { value: res?.data?.categoryId?._id, label: res?.data?.categoryId?.name } : null
        })
      }
      loader(false)
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    setSubmitted(true)
    let invalid = methodModel.getFormError(formValidation, form)
    if (invalid) return
    let method = "post"
    let url = "category/add"
    let value = {
      ...form,
      categoryId: form?.categoryId?.value || "",
      type: "child"
    }
    if (id) {
      method = "put"
      url = "category/update"
      value = {
        ...value,
        id: id,
      }
    } else {
      delete value.id
    }
    loader(true)
    ApiClient.allApi(url, value, method).then((res) => {
      if (res.success) {
        history(`/subcategory`)
      }
      loader(false)
    })
  }

  const ImageUpload = (e) => {
    let files = e.target.files
    let file = files.item(0)
    const allowedTypes = ["image/jpeg", "image/jpg", "image/png"]; // Add more image types if needed
    if (!allowedTypes.includes(file.type)) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Only JPG and PNG images are allowed.",
      });
      return;
    }
    loader(true)
    ApiClient.postFormData('upload/image', { file: file }).then(res => {
      if (res.success) {
        setform({ ...form, image: res?.fileName })
      }
      loader(false)
    })
  }

  return (
    <>
      <Layout>
        <form onSubmit={handleSubmit} autoComplete="one-time-code">
          <div className="pprofile1">
            <div className="flex items-center mb-8">
              <Tooltip placement="top" title="Back">
                <Link to={`/subcategory`} className="!px-4 py-2 flex items-center justify-center rounded-lg shadow-btn hover:bg-[#F3F2F5] border transition-all mr-3">
                  <i className="fa fa-angle-left text-lg"></i>
                </Link>
              </Tooltip>
              <div>
                <h3 className="text-lg lg:text-2xl font-semibold text-[#111827]">{id ? "Edit" : "Add"} Sub Category</h3>
              </div>
            </div>

            <h3 className="ViewUser mb-3"></h3>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              <div className=" mb-3">
                <FormControl
                  type="text"
                  name="name"
                  label="Name"
                  placeholder="Name"
                  value={form.name}
                  onChange={(e) => setform({ ...form, name: e })}
                  required
                />
              </div>

              <div className=" mb-3">
                <label>Category <span className="text-red-600"> *</span></label>
                <Select
                  value={form?.categoryId}
                  onChange={e => setform({ ...form, categoryId: e })}
                  options={categories}
                  className="capitalize"
                  required
                />
              </div>

              <div className="mb-3">
                <label className="lablefontcls">Image (JPG/PNG) </label>
                {form?.image ?
                  <div>
                    <span className="relative inline-block">
                      <img src={methodModel.userImg(form?.image)} className="rounded-full h-20 w-20 block" />
                      <IoCloseOutline className="absolute top-2 -right-5 pointer hover:text-red-600" onClick={e => setform({ ...form, image: "" })} size={25} />
                    </span>
                  </div>
                  :
                  <label className={`flex items-center justify-center cursor-pointer text-black-800 bg-[#fff] focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 border-2 border-dashed border-gray-200 w-full`} style={{ gap: '8px' }}>
                    <FiPlus />
                    <input
                      id="dropzone-file"
                      type="file"
                      className="hidden"
                      accept=".jpg, .jpeg, .png"
                      value={""}
                      onChange={ImageUpload}
                    />
                    Upload Image
                  </label>
                }
              </div>
            </div>

            <div className="text-right">
              <button type="submit" className="text-white bg-[#ffd6b6] bg-[#ffd6b6] focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2">
                {id ? "Update" : "Save"}
              </button>
            </div>
          </div>
        </form>
      </Layout>
    </>
  );
};

export default AddEditSubCategory;
